<template>
  <div :class="['fill-height', { primary: !$vuetify.breakpoint.lgAndDown }]">
    <v-container :class="['fill-height', 'pa-0', 'justify-center', 'align-center']">
      <v-dialog v-model="dialog" width="450">
        <v-card :disabled="loadingRestorePassword" :loading="loadingRestorePassword">
          <div v-if="!isSendEmail" class="pa-4">
            <v-card-title>
              Reestablecer contraseña
              <v-spacer></v-spacer>
              <v-btn icon @click="dialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text class="pb-3">
              <span>Ingresa tu correo y te enviaremos los pasos para reestablecer tu contraseña.</span>
              <v-text-field
                v-model="restoreEmail"
                class="mt-4 font-weight-bold"
                label="Correo"
                prepend-inner-icon="mdi-email"
                :error-messages="restoreEmailErrors"
                @input="$v.restoreEmail.$touch()"
                @blur="$v.restoreEmail.$touch()"
              ></v-text-field>
              <span v-if="errorRestorePassword" class="error--text font-weight-bold body-2">
                <v-icon color="error" class="mr-2">mdi-alert-circle</v-icon>
                {{ errorRestorePassword }}
              </span>
            </v-card-text>
            <v-card-actions class="px-5 pt-0">
              <BaseMyButton
                class="primary mb-4"
                block
                color="success"
                :disabled="$v.restoreEmail.$invalid"
                @click="restorePassword()"
              >
                <v-icon class="mr-4" small>mdi-email-send</v-icon>Enviar
              </BaseMyButton>
            </v-card-actions>
          </div>
          <div v-else class="pa-4">
            <v-card-title>
              Reestablecer contraseña
              <v-spacer></v-spacer>
              <v-btn icon @click="dialog = false; isSendEmail = false;">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text class="pb-3">
              <v-icon color="success" class="mr-2" small>mdi-check-circle</v-icon>
              <span>Le hemos enviado un correo con los pasos a seguir para restablecer su contraseña</span>
            </v-card-text>
          </div>
        </v-card>
      </v-dialog>
      <v-card
        :flat="$vuetify.breakpoint.lgAndDown"
        :style="{
          borderRadius: !$vuetify.breakpoint.lgAndDown
            ? '50px'
            : '',
          boxShadow: !$vuetify.breakpoint.lgAndDown
            ?'0px 5px 10px -2px rgba(207,50,0, .4) !important'
            : '',
          width: $vuetify.breakpoint.smAndDown ? '100%' : '100%'
        }"
        :class="{ 'pa-9': !$vuetify.breakpoint.lgAndDown }"
      >
        <v-container
          :class="!$vuetify.breakpoint.lgAndDown
          ? 'pa-9'
          : $vuetify.breakpoint.smAndDown
            ? 'px-10' : 'pa-0'
        "
        >
          <v-row>
            <v-col cols="12" sm="6" md="5">
              <v-container class="pa-0">
                <v-row>
                  <v-col class="mb-5">
                    <BaseMyButtonDirection
                      direction="left"
                      :animate="true"
                      :to="{ name: 'company' }"
                    ></BaseMyButtonDirection>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <p
                      class="display-2 font-weight-bold"
                    >{{siteSettings && siteSettings.pagina_empresa && siteSettings.pagina_empresa.inicio_sesion ? siteSettings.pagina_empresa.inicio_sesion.titulo : 'Hola,'}}</p>
                    <p
                      class="display-2 font-weight-bold mb-0"
                    >{{siteSettings && siteSettings.pagina_empresa && siteSettings.pagina_empresa.inicio_sesion ? siteSettings.pagina_empresa.inicio_sesion.subtitulo : 'Bienvenido'}}</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-form>
                      <v-text-field
                        v-model="usuario.correo"
                        label="Correo"
                        class="font-weight-bold"
                        :error-messages="correoErrors"
                        @input="$v.usuario.correo.$touch()"
                        @blur="$v.usuario.correo.$touch()"
                        required
                      ></v-text-field>
                      <v-text-field
                        v-model="usuario.password"
                        type="password"
                        label="Contraseña"
                        class="font-weight-bold"
                        @keypress.enter="login"
                        :error-messages="passwordErrors"
                        @input="$v.usuario.password.$touch()"
                        @blur="$v.usuario.password.$touch()"
                        required
                      ></v-text-field>
                      <div class="mt-4">
                        <span v-if="errorGlobal" class="error--text font-weight-bold body-2">
                          <v-icon color="error" class="mr-2">mdi-alert-circle</v-icon>
                          {{ errorGlobal }}
                        </span>
                        <div class="text-right">
                          <v-btn
                            text
                            color="primary"
                            class="font-weight-bold px-0 body-2"
                            :small="$vuetify.breakpoint.smAndDown"
                            @click="dialog = true"
                          >He olvidado mi contraseña</v-btn>
                        </div>
                        <BaseMyButton
                          class="primary mb-4 py-4"
                          block
                          @click="login"
                          :loading="loading"
                          :disabled="loading"
                        >INGRESAR</BaseMyButton>
                        <p class="primary--text">
                          No tienes una cuenta?
                          <router-link
                            class="font-weight-bold"
                            :to="{ name: 'company register' }"
                          >Click aquí</router-link>
                        </p>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row></v-row>
              </v-container>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="7"
              class="d-flex align-center"
              v-if="$vuetify.breakpoint.smAndUp"
            >
              <v-img
                v-if="siteSettings && siteSettings.pagina_empresa && siteSettings.pagina_empresa.inicio_sesion && siteSettings.pagina_empresa.inicio_sesion.imagen"
                :src="siteSettings && siteSettings.pagina_empresa && siteSettings.pagina_empresa.inicio_sesion && siteSettings.pagina_empresa.inicio_sesion.imagen"
                contain
              ></v-img>
              <v-img v-else src="@/assets/company-contract.svg" contain></v-img>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";

export default {
  name: "Login",
  mixins: [validationMixin],
  validations: {
    usuario: {
      correo: { required, email },
      password: { required }
    },
    restoreEmail: { required, email }
  },
  data() {
    return {
      loading: false,
      errorGlobal: "",
      errorRestorePassword: "",
      usuario: {
        correo: "",
        password: ""
      },
      restoreEmail: "",
      dialog: false,
      loadingRestorePassword: false,
      isSendEmail: false
    };
  },
  computed: {
    ...mapState(["siteSettings"]),
    correoErrors() {
      const errors = [];
      if (!this.$v.usuario.correo.$dirty) return errors;
      !this.$v.usuario.correo.email && errors.push("Ingrese un correo valido");
      !this.$v.usuario.correo.required && errors.push("Correo obligatorio");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.usuario.password.$dirty) return errors;
      !this.$v.usuario.password.required && errors.push("Password obligatorio");
      return errors;
    },
    restoreEmailErrors() {
      const errors = [];
      if (!this.$v.restoreEmail.$dirty) return errors;
      !this.$v.restoreEmail.email && errors.push("Ingrese un correo valido");
      !this.$v.restoreEmail.required && errors.push("Correo obligatorio");
      return errors;
    }
  },
  methods: {
    ...mapActions(["setMemberToken"]),
    login() {
      this.$v.$touch();
      if (this.$v.usuario.$invalid) return;
      this.loading = true;
      this.axios
        .post("/api/empresas/miembros/iniciar-sesion", this.usuario)
        .then(res => {
          const token = res.data;
          this.setMemberToken(token);
          this.$router.push({ name: "company app" });
        })
        .catch(err => {
          if (err.response) this.errorGlobal = err.response.data.message;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    restorePassword() {
      this.$v.restoreEmail.$touch();
      if (this.$v.restoreEmail.$invalid) return;
      this.errorRestorePassword = "";
      this.loadingRestorePassword = true;
      this.axios
        .patch("/api/empresas/miembros/restaurar-password-email", {
          correo: this.restoreEmail
        })
        .then(res => {
          this.isSendEmail = true;
          this.restoreEmail = "";
          this.$v.restoreEmail.$reset();
        })
        .catch(err => {
          if (err.response)
            this.errorRestorePassword = err.response.data.message;
        })
        .finally(() => {
          this.loadingRestorePassword = false;
        });
    }
  }
};
</script>